import { tosAcceptanceProps } from "types/v1/system/tosAcceptanceProps";
import Input from "../main/form/Input";
import { useState } from "react";
import { format } from "date-fns";
import { VssSystemFeature } from "types/v1/system/systemFeatureType";

const TosAcceptComponent = (props: tosAcceptanceProps) => {
	const [accepted, setAccepted] = useState<boolean>(false);

	const tosDateString = (date: Date) => {		
		let convertDate = new Date(date);
		return format(convertDate, 'MMMM dd, yyyy');
	};

	const acceptTos = (accept: boolean) => {
		setAccepted(accept);
		let acceptanceShallow = { ...props.tos };
		if (accept) {
			acceptanceShallow.dateAccepted = new Date();
		}
		else {
			acceptanceShallow.dateAccepted = null;
		}
		props.acceptCallback(acceptanceShallow);
	}

	const acceptBox = () => {
		
		return (
			<>
			I accept the <b><a href={`/app/tos/${props.tos?.termsOfServiceTypeId}`} target="_blank">{props.tos.termsOfServiceName}</a></b> <i>Last Updated: {tosDateString(props.tos.dateStart)}</i>
			</>
		)
	}

	return (
		<>
			<div className="row" style={{ marginTop: "10px" }}>
				<div className="col-12">
					<Input.Checkbox onChange={e => acceptTos(e.checked ?? false)} checked={accepted} name={`acceptTOS_${props.tos.termsOfServiceId}`} label={acceptBox()}></Input.Checkbox >
				</div>
			</div>
			{props.tos.termsOfServiceTypeId == VssSystemFeature.systemFeatureTypeId && 
				<br/>
			}
		</>
	)
}

export default TosAcceptComponent;